/**
 * Le palier de maîtrise — ce qui remplace le pourcentage, partout.
 *
 * Le contrat n'expose que CINQ paliers discrets par savoir PDA
 * (`NIVEAUX_MAITRISE` : non_evalue → maitrise). Le LIBELLÉ est la donnée ; les
 * cinq segments ne sont qu'une échelle de POSITION, toujours accompagnée du
 * libellé, jamais seule, jamais additionnée, jamais moyennée. Aucun chiffre
 * n'est affiché, et l'échelle est `aria-hidden` : un lecteur d'écran lit le
 * palier en toutes lettres, pas « 3 sur 5 ».
 *
 * La teinte d'attention est réservée au panier « à surveiller » du critère de
 * recommandation (non évalué / en découverte). Ce n'est pas un rouge : le seul
 * rouge de la console est le signal de détresse.
 */
import type { NiveauMaitrise } from '@silex/shared';

import { estASurveiller, libellePalier, NB_PALIERS, positionPalier } from '../lib/tuteur-format';

export function PalierMaitrise({ niveau }: { niveau: NiveauMaitrise }) {
  const rang = positionPalier(niveau);
  const classe = estASurveiller(niveau) ? 'palier palier--watch' : 'palier';

  return (
    <span className={classe}>
      <span className="pal-steps" aria-hidden="true">
        {Array.from({ length: NB_PALIERS }, (_, i) => (
          <i key={i} className={i < rang ? 'on' : undefined} />
        ))}
      </span>
      <span className="pal-lbl">{libellePalier(niveau)}</span>
    </span>
  );
}

/** La légende de l'échelle — dite une fois par écran qui la montre. */
export function LegendePalier() {
  return (
    <p className="pal-legend">
      Cinq paliers : non évalué · en découverte · en consolidation · en voie de maîtrise · maîtrisé.
      Jamais de pourcentage, jamais de moyenne.
    </p>
  );
}
